import React from 'react';
import DataSourceCard from './DataSourceCard';
import './AddNewConnection.css';
import { faDatabase } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const AddNewConnection: React.FC = () => {
    return (
        <div className="new-data-sources-page">
            <h2>Add new data Source</h2>
            <p>Browse and create new connections</p>
            <input placeholder="Search for a data source" />
            <h2><FontAwesomeIcon icon={faDatabase} /> Data Sources</h2>
            <div className="new-data-sources-container">
                <DataSourceCard
                    logo="/images/prometheus-logo.svg"
                    name="Prometheus"
                    url="prometheus"
                />
                {/*<DataSourceCard*/}
                {/*    logo="/images/logo-mysql-170x115.png"*/}
                {/*    name="MySQL"*/}
                {/*    url="mysql"*/}
                {/*/>*/}
            </div>
        </div>
    );
}

export default AddNewConnection;
